/**
 * Thin wrappers around the native plugins. Every call is a no-op on the web,
 * so nothing about the website changes for browser visitors.
 */

import { isNativeApp } from "./native-app";

export async function hapticSelection(): Promise<void> {
  if (!isNativeApp()) return;
  try {
    const { Haptics, ImpactStyle } = await import("@capacitor/haptics");
    await Haptics.impact({ style: ImpactStyle.Light });
  } catch {
    /* haptics are a nicety, never a failure */
  }
}

export async function configureNativeChrome(): Promise<void> {
  if (!isNativeApp()) return;
  try {
    const { StatusBar, Style } = await import("@capacitor/status-bar");
    await StatusBar.setStyle({ style: Style.Light });
  } catch {
    /* status bar styling is optional */
  }
  try {
    const { SplashScreen } = await import("@capacitor/splash-screen");
    await SplashScreen.hide();
  } catch {
    /* splash may already be hidden */
  }
}

/**
 * Hardware/gesture back inside the app: go back in history, and never close
 * the app from a deep screen without warning.
 */
export async function installNativeBackHandler(onBack: () => boolean): Promise<() => void> {
  if (!isNativeApp()) return () => {};
  try {
    const { App } = await import("@capacitor/app");
    const handle = await App.addListener("backButton", () => {
      onBack();
    });
    return () => {
      void handle.remove();
    };
  } catch {
    return () => {};
  }
}
